/**
 * Signup form constants and utilities.
 * Shared between HeaderFeature and ModalSignupFormFeature to avoid duplication.
 */

/**
 * Primary hash identifier for signup form deep-linking.
 * Always static — never translated — so that hash-based triggering
 * works consistently across all locales.
 */
export const SIGNUP_FORM_HASHES = ['requestaccount', 'Requestaccount', 'RequestAccount'];

/**
 * Build the complete set of valid hashes for signup form modal trigger.
 * Includes the static hash and variations of the locale-translated text
 * to handle deep-links authored in the CMS.
 * @param normalizedTranslatedText - URL-encoded translation without spaces (from any locale)
 */
export const getSignupFormValidHashes = (normalizedTranslatedText: string): string[] => [
	...SIGNUP_FORM_HASHES,
	normalizedTranslatedText,
	normalizedTranslatedText.toLowerCase(),
	normalizedTranslatedText.toUpperCase(),
];

/**
 * Normalize a string to a URL-safe hash format.
 * Removes whitespace and URL-encodes the result.
 */
export const normalizeToHash = (text: string): string => {
	if (!text) return '';
	return encodeURIComponent(text.replace(/\s/gi, ''));
};
